import { FC, useState } from 'react';

import { ReactComponent as AttachmentIcon } from '../../../../assets/icons/attachment.svg';
import { useAppDispatch } from '../../../../hooks';
import { getFileViewUrl } from '../../../../reducers/work';
import { colors } from '../../../../theme';
import { Attachment } from '../../../../types/work';
import { getFileIcon } from '../../../../utils/fileTypeHelpers';
import AttachmentPopup from '../../components/AttachmentPopup';
import S from './styled';

interface Props {
    attachments: Attachment[];
}

const SolutionAttachments: FC<Props> = ({ attachments }) => {
    const dispatch = useAppDispatch();

    const [ popupState, setPopupState ] = useState({
        isOpen: false,
        url: '',
        type: '',
        name: '',
        fileId: 0,
        currentIndex: 0
    });

    const getAttachmentUrl = async (file: Attachment, index: number) => {
        try {
            const response = await dispatch(getFileViewUrl({ fileId: Number(file.id) })).unwrap();
            setPopupState({
                isOpen: true,
                url: response.url,
                type: file.type || '',
                name: file.name || '',
                fileId: Number(file.id),
                currentIndex: index
            });
        } catch (error) {
            console.error('Error fetching attachment URL:', error);
        }
    };

    const closePopup = () => {
        setPopupState(prev => ({ ...prev, isOpen: false }));
    };

    const handleNextAttachment = async () => {
        if (!attachments || attachments.length === 0) {
            return;
        }

        const nextIndex = 
            (popupState.currentIndex + 1) % attachments.length;
        const nextFile = attachments[nextIndex];

        await getAttachmentUrl(nextFile, nextIndex);
    };

    if (!attachments || attachments.length === 0) {
        return null;
    }

    return (
        <S.Root>
            <AttachmentPopup
                isOpen={popupState.isOpen}
                onClose={closePopup}
                url={popupState.url}
                type={popupState.type}
                name={popupState.name}
                fileId={popupState.fileId}
                currentIndex={popupState.currentIndex + 1}
                totalItems={attachments?.length || 0}
                onNext={handleNextAttachment}
            />
            <S.TitleContainer>
                <AttachmentIcon color={colors.yellow} />
                <S.Title>Proof of Work</S.Title>
            </S.TitleContainer>
            <S.Instructions>
                    Ensure the files shows that the development meets the original task requirements.
            </S.Instructions>
            <S.AttachmentsContainer>
                <S.AttachmentsHeader variant="subtitle2">
                    Attachments
                </S.AttachmentsHeader>
                <S.AttachmentsGrid>
                    {attachments.map((file, index) => (
                        <S.AttachmentItem
                            key={`attachment-${file.id}`}
                            onClick={() => getAttachmentUrl(file, index)}
                        >
                            {getFileIcon(file.type || '')}
                            <span>{file.name}</span>
                        </S.AttachmentItem>
                    ))}
                </S.AttachmentsGrid>
            </S.AttachmentsContainer>
        </S.Root>
    );
};

export default SolutionAttachments; 
